import React from 'react';
import ReactDOM from "react-dom/client";

export default function scReactHarness(ComponentTypes) {
  document.addEventListener('DOMContentLoaded', () => {
    function initialize(componentContainer) {
      const props = JSON.parse(componentContainer.dataset.props || '{}');

      const root = ReactDOM.createRoot(document.getElementById('root'));
      root.render(React.createElement(ComponentTypes[componentContainer.dataset.reactComponent], props));
    }

    let reactComponents = document.querySelectorAll('[data-react-component]');
    reactComponents = Array.prototype.slice.call(reactComponents);
    reactComponents.forEach(initialize);
  });
}